import cookie from 'js-cookie'

function parseSearchParams(query){
    query = query.substr(1);
    var result = {};
    query.split("&").forEach( (part) => {
        var item = part.split("=");
        result[item[0]] = decodeURIComponent(item[1]);
    });
    return result
}

function sendToSalesFlow( club_product_id, club_number, userData ){
    cookie.set( 'enteredInfo', userData, {
        expires: ( new Date().getTime() + 300000 ),
        path: '/',
        domain: window.location.hostname,
        secure: true
    } );

    window.name = '';

    var iframe = document.createElement('iframe'),
        host = window.location.hostname,
        dgrSection = document.querySelector( '.dgrSection' );
    iframe.id = 'hiddenframe';
    iframe.src = 'https://' + host + '/membershipSalesOnline';
    if ( dgrSection ) {
        var str = '<div id="loading">';
        str += '<h1>Loading...</h1>';
        str += '</div>';
        dgrSection.innerHTML = str;
    }
    document.body.appendChild( iframe );

    // Wait a couple of seconds.
    setTimeout( function() {
        var contentDoc = ( iframe.contentWindow || iframe.contentDocument );
        try {
            if ( contentDoc && contentDoc.document ) contentDoc = contentDoc.document;
            // Delete any old session cookies, so we can start fresh.
            contentDoc.cookie = 'JSESSIONID= ; Path=/membershipSalesOnline;';
            contentDoc.cookie = 'JSESSIONID= ; Path=/;';
        } catch (o_0) {}

    var redirectUrl = 'http://';
    redirectUrl += host;
    redirectUrl += '/go/dgr/membership_delegate.html';
    if ( club_product_id === 'costco' || club_product_id === 'corporate' ) {
        redirectUrl += '?product_type=' + club_product_id;
    } else {
        redirectUrl += '?product_type=normal';
        redirectUrl += '&product_id=' + club_product_id;
    }
    redirectUrl += '&club_number=' + club_number;
    redirectUrl += '&lead_number=' + userData.lead_number;
    redirectUrl += '&ran=' + new Date().getTime();

    window.location.href = redirectUrl;

    }, 2000);

}

function setDigitalData( page_name, club_number ){
    var clubId = ( ''+club_number ).substring(2);
    window.digitalData = { 
        page: {
            pageInfo: {
                siteName: "24hf",
                pageCategory: "dgr",
                pageName: '24hf|dgr|' + page_name + '|',
                clubId: clubId
            }
        }
    };
    if ( console && console.log ) console.log( page_name, window.digitalData );
}

export {  parseSearchParams, sendToSalesFlow, setDigitalData  }



// WEBPACK FOOTER //
// ./src/components/Utilities/Utils.js